// use strict

import { useEffect, useState } from 'react'
import * as Sentry from "@sentry/nextjs";
import { useRouter } from 'next/router'

import firebase, { auth } from 'utils/firebase'
import { routes, authErrors } from 'utils/constants'
import { setSessionRedirected, getSessionRedirected, removeSessionRedirected, setUser, setCurrentStore, setSearchAll } from 'utils/selectors'
import { makeUser } from 'utils/helpers'
import { useData } from 'utils/context'
import { fetchEmployee } from 'utils/firestore/employees'


const setHangError = () => {
  let maxHangTime = 10000
  return setTimeout(() => {
    Sentry.captureMessage(authErrors.timeout, 'error');
  }, maxHangTime)
}

const useLogin = () => {
  const router = useRouter()
  const { dispatchUser, dispatchCurrentStore, dispatchSearchAll } = useData() 
  const [error, setError] = useState(null)
  const [loading, setloading] = useState(false)

  const login = () => {
    try {
      setError(null)
      const provider = new firebase.auth.GoogleAuthProvider();
      auth.signInWithRedirect(provider);
      setSessionRedirected()
    } catch(e) {
      Sentry.captureException(e);
    }
  }
  useEffect(() => {
    let hangTimeOut = null 
    if (getSessionRedirected()) {
      hangTimeOut = setHangError()
      setloading(true)
      auth.getRedirectResult().then(async function(result) {
        try {
          let claims = null
          if (!result.credential) throw new Error(authErrors.google_auth)
          const { claims: userClaims } = await result.user.getIdTokenResult(true)
          claims = userClaims
          if (!Object.keys(claims).includes('storeIds') || !Object.keys(claims).includes('isActive') || !claims.isActive) {
            let employee = await fetchEmployee(result.user.email)
            claims = { ...employee, storeIds: employee?.stores || [] }
          }
          const authUser = makeUser({ user: result.user, claims })
          
          dispatchUser(authUser)
          if (authUser.defaultStore) {
            dispatchCurrentStore(authUser.defaultStore)
            setCurrentStore(authUser.defaultStore)
          } else if (authUser.stores.length > 1) {
            dispatchSearchAll()
            setSearchAll()
          } else  {
            dispatchCurrentStore(authUser.stores[0])
            setCurrentStore(authUser.stores[0])
          }
          setUser(authUser)
          removeSessionRedirected()
          setloading(false)
          await router.push(routes.home)
        }
        catch (e) {
          setError(e.message)
          console.log(e);
          removeSessionRedirected()
          setloading(false)
          Sentry.captureException('Login Failed - '+ e.message, 'error');
        }
      }).catch(function(error) {
        /**
         *  Handle Errors here.
         *  */
        setError(error.message)
        setloading(false)
        removeSessionRedirected()
        Sentry.captureException(error);
      });
    }
    return () => {
      clearTimeout(hangTimeOut)
    }
  }, [])
  return { loading, error, login }
}

export default useLogin
